import {
  differenceInDays,
  format,
  formatDistanceToNow,
  isValid,
  parseISO,
} from 'date-fns';

const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  if (typeof value === 'string') {
    const parsed = parseISO(value);
    return isValid(parsed) ? parsed : null;
  }
  const d = new Date(value);
  return isValid(d) ? d : null;
};

// "May 21, 2026"
export const formatDate = (value, fallback = '—') => {
  const d = toDate(value);
  return d ? format(d, 'MMM d, yyyy') : fallback;
};

// "May 21, 2026 · 11:38 AM"
export const formatDateTime = (value, fallback = '—') => {
  const d = toDate(value);
  return d ? format(d, "MMM d, yyyy '·' h:mm a") : fallback;
};

// "11:38 AM"
export const formatTime = (value, fallback = '—') => {
  const d = toDate(value);
  return d ? format(d, 'h:mm a') : fallback;
};

// Smart: "5m ago" / "3d ago" / "May 21, 2026"
export const formatRelative = (value, fallback = '—') => {
  const d = toDate(value);
  if (!d) return fallback;
  const days = Math.abs(differenceInDays(new Date(), d));
  if (days < 7) return formatDistanceToNow(d, { addSuffix: true });
  return format(d, 'MMM d, yyyy');
};

// 1234567 → "1.2M", 1234 → "1.2k"
export const formatCompact = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  const num = Number(n);
  if (Math.abs(num) >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
  if (Math.abs(num) >= 1_000) return `${(num / 1_000).toFixed(1)}k`;
  return num.toLocaleString();
};

// 1234567 → "1,234,567"
export const formatNumber = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return Number(n).toLocaleString();
};
